export enum MzicPopoverStyleEnum {
  TOOLTIP = 'style-tooltip',
  SMALL_DARK = 'style-dark-small',
  SMALL_WHITE = 'style-white-small',
  MODAL = 'modal-popover',
  DIALOG = 'mzic-dialog',
}
